module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FBI0A1/tc-custom/9781466812819.jpg?1737766217233",
      "alt": "This image is the cover for the book Moving Targets"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Moving Targets\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“A genuine blockbuster . . . With this novel, Sean Flannery takes his rightful place along such masters as Tom Clancy and Clive Cussler.” —Ed Gorman, "), _c('i', [_vm._v("Mystery Scene")])]), _c('br'), _c('br'), _vm._v("The Cold War is over—followed by a deadlier menace than the world has ever known. Its codename: Operation Homeward Bound. Deep within the KGB, a dedicated fraternity conspires to restore the power of its fragmented homeland. Brutal, power-crazed, ruthlessly efficient, these renegade agents want nothing less than the destruction of the US."), _c('br'), _c('br'), _vm._v("To insure its mission, this sinister coterie will use every weapon available. Torture. Murder. Even the family of a US security adviser."), _c('br'), _c('br'), _c('b', [_vm._v("“Not only do Flannery’s spy thrillers have the ring of truth; sometimes they "), _c('i', [_vm._v("become")]), _vm._v(" the truth. Let’s hope "), _c('i', [_vm._v("Moving Targets")]), _vm._v(" remains fiction.” —Dean Ing, "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author")]), _c('br'), _c('br'), _c('b', [_vm._v("“Full of intriguing, fully drawn characters from both sides of the old cold war . . . [A] clever and thoroughly believable painting of interagency warfare, diverted loyalties, and political confusion in our time. Quite good.” —"), _c('i', [_vm._v("Kirkus Reviews")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sean Flannery\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0